import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ClientMenu from '../components/clientMenu';
import ClientDetails from './clientDetails';
import RequestList from './requestDetails';

function ClientRoutes() {
    return (
        <div className='container-fluid mt-5'>
            <div className='row'>
                {/* Sidebar - 2 columns */}
                <div className='col-2 p-0'>
                    <ClientMenu /> {/* Sidebar is always shown on admin routes */}
                </div>

                {/* Main content area - 10 columns */}
                <div className='col-10 user-content pt-5'>
                    <Routes>
                        {/* Default route */}
                        <Route path="/" element={<ClientDetails />} />

                        {/* Booking list route */}
                        <Route path='/requestDetail' element={<RequestList />} />
                    </Routes>
                </div>
            </div>
        </div>
    );
}

export default ClientRoutes;
